import axios from 'axios'
import { API_URL } from '../../../../../../constants'
import { ApiResponse } from '../../../../../common/api/response.types'
import { ISystemSetting, ISettingsService } from './response.types'
import { SystemSettingsListQuery } from './query.types'

export const getSettingsServices = () => {
  return axios.get<ApiResponse<ISettingsService[]>>(`${API_URL}/api/internal/settings/services`)
}

export const getSystemSettingsList = (params: SystemSettingsListQuery) => {
  return axios.get<ApiResponse<ISystemSetting[]>>(`${API_URL}/api/internal/settings`, { params })
}

export const updateSystemSetting = (service: string, key: string, value: string) => {
  return axios.put<ApiResponse<ISystemSetting>>(
    `${API_URL}/api/internal/settings/${service}/${encodeURIComponent(key)}`,
    { value }
  )
}
